





































































































  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import Template from '@/views/reports/forms/traffic_sources/template.vue';
  import UrlMixin from '@/components/query/url-mixin';
  import { mixins } from 'vue-class-component';
  @Component({
    components: {Template}
  })
  export default class NavbarWorkspacesMenu extends mixins(UrlMixin)  {
    @Prop()
    closeMenu: any;

    @Prop({default:false})
    isMobile: boolean;

    allWorkspaces: any = [];
    selectedWorkspaces: any = [];

    get isSelectedAll(){
      return (this.selectedWorkspaces && this.selectedWorkspaces.length)
        === (this.$store.state.user.workspaces && this.$store.state.user.workspaces.length)
    }

    set isSelectedAll(value: boolean) {
      if(value) {
        this.selectedWorkspaces = this.$store.state.user.workspaces.map((workspace:any)=>workspace.id)
      } else {
        this.selectedWorkspaces = []
      }
    }

    get textColor(){
      return this.isMobile ? this.$colors.gray20 : this.$colors.graphite;
    }

    apply(){
      this.bus.emit('reset-pagination');
      this.$store.commit('updateUser', {
        selectedWorkspaces: [
          ...this.selectedWorkspaces
        ]
      })
      if (this.closeMenu){
        this.closeMenu()
      }
      if(this.isDashbord){
        this.bus.emit('refresh-dashboard');
      }
    }

    @Watch('$store.state.user',{ immediate: true })
    updateWorkspaces(val: any) {
      const {workspaces,selectedWorkspaces} = val;
      if(workspaces){
        this.allWorkspaces = [...workspaces];
      }
      if(workspaces){
        this.selectedWorkspaces = [...selectedWorkspaces];
      }
    } 
}
